import { render } from "./ModalNuovoRimborso.vue?vue&type=template&id=f4ac8688&scoped=true"
import script from "./ModalNuovoRimborso.vue?vue&type=script&lang=js"
export * from "./ModalNuovoRimborso.vue?vue&type=script&lang=js"

import "./ModalNuovoRimborso.vue?vue&type=style&index=0&id=f4ac8688&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_v2/app_ambient/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4ac8688"]])

export default __exports__